module.exports = __webpack_public_path__ + "img/man-head-back.af5e0d89.png";